import CommonAPIService from "src/servicehandlers/CommonHandler";

export class AuthGroupAPIService {
  constructor() {
    this.search = "";
    this.firm = "";
    this.CommonAPIService = new CommonAPIService();
  }

  getAuthGroups(router) {
    const url = "/api/authGroups";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getAuthGroupHosts(router) {
    const url = `/api/authGroups/hosts`;
    return this.CommonAPIService.getCall(url, null, router);
  }
  getActiveFlightSchoolSpecificAuthGroups(id = undefined, router) {
    const url = `/api/authGroups?active=true&isFlightSchoolSpecific=true&flightSchoolId=${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getAuthGroupsById(id, router) {
    const url = `/api/authGroups/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getAuthGroupsWithScope(id, router) {
    const url = `/api/authGroups/${id}/scopes`;
    return this.CommonAPIService.getCall(url, "", router);
  }
  getAuthGroupsWithUsers(id, router) {
    const url = `/api/authGroups/${id}/linked_users`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  addAuthGroup(router, params) {
    const url = `/api/authGroups`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  deleteAuthGroup(router, id) {
    const url = `/api/authGroups/${id}`;
    return this.CommonAPIService.deleteCall(url, "", router);
  }

  updateAuthGroup(router, id, params) {
    const url = `/api/authGroups/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  searchAuthGroups(router, search) {
    const url = `/api/authGroups?search=${search}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  addUserToAuthGroups(userid, groups, router) {
    const url = `/api/authGroups/${userid}/user`;
    return this.CommonAPIService.postCall(url, { groups }, router);
  }

  removeUserFromAuthGroup(router, userid, groupid) {
    const url = `/api/authGroups/${groupid}/users/${userid}`;
    return this.CommonAPIService.deleteCall(url, "", router);
  }

  addScopeToAuthGroup(groupid, scopeid, router) {
    const url = `/api/authGroups/${groupid}/scopes/${scopeid}`;
    return this.CommonAPIService.putCall(url, null, router);
  }

  removeScopeFromAuthGroup(groupid, scopeid, router) {
    const url = `/api/authGroups/${groupid}/scopes/${scopeid}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  getLinkedAuthgroupScopes(id, router) {
    const url = `/api/authGroups/${id}/linked_scopes`;
    return this.CommonAPIService.getCall(url, null, router);
  }
  getLinkedAuthgroupsCommandLookups(id, router) {
    const url = `/api/authGroups/${id}/linked_command_lookups`;
    return this.CommonAPIService.getCall(url, null, router);
  }
  getLinkedAuthgroupHosts(id, router) {
    const url = `/api/authGroups/${id}/linked_hosts`;
    return this.CommonAPIService.getCall(url, null, router);
  }
  linkAuthgroupToScopes(id, scope_ids, router) {
    const url = `/api/authGroups/${id}/${scope_ids}/link_scopes`;
    return this.CommonAPIService.getCall(url, null, router);
  }
  linkAuthgroupToCommandLookups(id, command_lookup_ids, router) {
    const url = `/api/authGroups/${id}/${command_lookup_ids}/link_command_lookups`;
    return this.CommonAPIService.getCall(url, null, router);
  }
  linkAuthgroupToHosts(id, host_ids, router) {
    const url = `/api/authGroups/${id}/${host_ids}/link_hosts`;
    return this.CommonAPIService.getCall(url, null, router);
  }
  linkAuthgroupToUsers(params, router) {
    const url = `/api/authGroups/link_users`;
    return this.CommonAPIService.postCall(url, params, router);
  }
}

export default AuthGroupAPIService;
